/** @format */

import axios from "axios";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_Users;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listar: async (id, alertMessage) => {
    try {
      let result = await axios.get(`${ENDPOINT}${id}`, { headers: headers });
      if (result.data.Status == "NOK") {
        return getAlert(
          Constantes().msmEstudiante,
          dataUser == null ? "./Login" : "",
          alertMessage
        );
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(Constantes().SeccionExpirada, "./Login");
    }
  },
};

export default API;
